import { ShouldRenderTabsService } from '@philips-emr/hpms-provider-accreditation-commons';
import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

@Controller({ fragment: 'provider-accreditation-beds-and-equipments' })
export default class ProviderAccreditatonServiceMaterialsController extends BaseController {

  @OnMount('tab-control')
  onMountTabControl(event: MountEvent): void {
    const { nrSeqUser, nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqUser, nrSeqAccreditation });
    const api = event.target as TabControlAPI;
    ShouldRenderTabsService.chooseDefaultTab(api, ['beds', 'equipments']);
  }

  @OnMount('tab-with-content-beds')
  onMountBeds(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'beds');
  }

  @OnMount('tab-with-content-equip')
  onMountEquipTab(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'equipments');
  }

}
